<template>
  <TransactionBulks />
</template>

<script>
import TransactionBulks from '../components/TransactionBulks.vue'

export default {
  components: {
    TransactionBulks,
  },
}
</script>

<style>

</style>
